/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MerchantTabRefetchQueryVariables = {
    merchantId: string;
    first?: number | null | undefined;
    after?: string | null | undefined;
    last?: number | null | undefined;
    before?: string | null | undefined;
    around?: string | null | undefined;
    when?: string | null | undefined;
    canReadHistory: boolean;
    canReadBalance: boolean;
};
export type MerchantTabRefetchQueryResponse = {
    readonly node: {
        readonly " $fragmentRefs": FragmentRefs<"MerchantTab_merchant">;
    } | null;
};
export type MerchantTabRefetchQuery = {
    readonly response: MerchantTabRefetchQueryResponse;
    readonly variables: MerchantTabRefetchQueryVariables;
};



/*
query MerchantTabRefetchQuery(
  $merchantId: ID!
  $first: Int
  $after: DateTime
  $before: DateTime
  $around: ID
  $when: DateTime
  $canReadHistory: Boolean!
  $canReadBalance: Boolean!
) {
  node(id: $merchantId) {
    __typename
    ... on Merchant {
      ...MerchantTab_merchant_2ksLMu
    }
    id
  }
}

fragment ChangePayoutRecipient_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment HistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment MerchantAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  isDeposit
  amount
  cashierName: counterpartyNameOnly
  cashierMobile: maybeTerminatedCustomerMobile
  agentId
  agentUfid
  agentName
  subagentId
  subagentName
  subagentUfid
  type
  isCancelled
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
}

fragment MerchantHistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  __typename
  ...HistoryEntry_entry
  ...MerchantSaleEntry_tx
  ...MerchantTransferSentEntry_tx
  ...MerchantAtxEntry_tx
  ...PayoutTransferEntry_tx
  ...PayoutTransferSentEntry_tx
}

fragment MerchantSaleEntry_tx on MerchantSaleEntry {
  maybeTransferId: transferId
  maybeSenderName: senderName
  maybeSenderMobile: senderMobile
  maybeTerminatedSenderMobile
  qrText
  merchantUName
  actionSource
  isRefunded
  isRemote
  ...HistoryEntry_entry
  ...RefundMerchantSale_transfer
}

fragment MerchantTab_merchant_2ksLMu on Merchant {
  id
  ufid
  name
  city
  region
  subcity
  country
  nearbyLandmark
  isActive
  whenDeactivated
  deactivatedBy
  deactivatedBecause
  photos {
    url
  }
  promotedBy {
    name
    mobile
    id
  }
  activeKybGracePeriod {
    kybTierGranted
  }
  businessNetwork {
    name
    wallets {
      walletId
    }
  }
  ...MerchantUsersList_merchant
  wallet {
    id
    balance @include(if: $canReadBalance)
    name
    mobile
    kybTier
    photoEditUrl
    merchantSupportEscalations {
      whenOpened
      status
      clickupTaskId
    }
    supportHistoryConnection(first: $first, after: $after, last: 30, before: $before, around: $around, when: $when) @include(if: $canReadHistory) {
      edges {
        node {
          __typename
          id
          ... on MerchantSaleEntry {
            maybeTransferId: transferId
          }
          ... on PayoutTransferEntry {
            __typename
            tcid
            amount
            whenEntered
          }
          ...MerchantHistoryEntry_entry
          ... on AgentTransactionEntry {
            agentTransactionId
          }
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
}

fragment MerchantTransferSentEntry_tx on TransferSentEntry {
  tx_id: transferId
  sender: senderName
  mobile: senderMobile
  recipientName
  recipientMobile
  maybeTerminatedRecipientMobile
  amount
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
  ...RefundP2P_transfer
}

fragment MerchantUsersList_merchant on Merchant {
  principal {
    id
    name
    contactMobile
  }
  assistants {
    id
    name
    mobile
  }
}

fragment PayoutTransferEntry_tx on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  senderName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment PayoutTransferSentEntry_tx on PayoutTransferEntry {
  tcid
  senderOpaqueId
  amount
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment RefundMerchantSale_transfer on MerchantSaleEntry {
  id
  maybeTransferId: transferId
  maybeSenderName: senderName
  maybeSenderMobile: senderMobile
  grossAmount
}

fragment RefundP2P_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  sendAmount
  receiveAmount
  senderName
  senderMobile
  recipientName
  maybeTerminatedRecipientMobile
}

fragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "around"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "merchantId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "when"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "merchantId"
  }
],
v10 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v11 = {
  "kind": "Variable",
  "name": "around",
  "variableName": "around"
},
v12 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v13 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v14 = {
  "kind": "Variable",
  "name": "when",
  "variableName": "when"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v22 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Literal",
    "name": "last",
    "value": 30
  },
  (v14/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceModel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userInterface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentMobile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamReportTicket",
  "kind": "LinkedField",
  "name": "scamReports",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whenResolved",
      "storageKey": null
    },
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/)
  ],
  "type": "TransferSentEntry",
  "abstractKey": null
},
v33 = {
  "alias": "sender",
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientMobile",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*: any*/)
  ],
  "type": "AgentTransactionEntry",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MerchantTabRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "canReadBalance",
                    "variableName": "canReadBalance"
                  },
                  {
                    "kind": "Variable",
                    "name": "canReadHistory",
                    "variableName": "canReadHistory"
                  },
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "last",
                    "variableName": "last"
                  },
                  (v14/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "MerchantTab_merchant"
              }
            ],
            "type": "Merchant",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "MerchantTabRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ufid",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "region",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subcity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nearbyLandmark",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "whenDeactivated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deactivatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deactivatedBecause",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MerchantPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "promotedBy",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "KybGracePeriod",
                "kind": "LinkedField",
                "name": "activeKybGracePeriod",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kybTierGranted",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BusinessNetwork",
                "kind": "LinkedField",
                "name": "businessNetwork",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BusinessNetworkWallet",
                    "kind": "LinkedField",
                    "name": "wallets",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "walletId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactMobile",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MerchantAssistant",
                "kind": "LinkedField",
                "name": "assistants",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Wallet",
                "kind": "LinkedField",
                "name": "wallet",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kybTier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoEditUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MerchantSupportEscalationTicket",
                    "kind": "LinkedField",
                    "name": "merchantSupportEscalations",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clickupTaskId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "canReadBalance",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v21/*: any*/)
                    ]
                  },
                  {
                    "condition": "canReadHistory",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v22/*: any*/),
                        "concreteType": "SupportHistoryConnection",
                        "kind": "LinkedField",
                        "name": "supportHistoryConnection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SupportHistoryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": "maybeTransferId",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "transferId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MerchantSaleEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "tcid",
                                        "storageKey": null
                                      },
                                      (v23/*: any*/),
                                      (v24/*: any*/)
                                    ],
                                    "type": "PayoutTransferEntry",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v24/*: any*/),
                                      (v23/*: any*/),
                                      (v21/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isDeposit",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "cashierName",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "counterpartyNameOnly",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "cashierMobile",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maybeTerminatedCustomerMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "type",
                                            "storageKey": null
                                          },
                                          (v30/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v32/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "AgentTransactionEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "alias": "tx_id",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "transferId",
                                            "storageKey": null
                                          },
                                          (v33/*: any*/),
                                          {
                                            "alias": "mobile",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "recipientName",
                                            "storageKey": null
                                          },
                                          (v34/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maybeTerminatedRecipientMobile",
                                            "storageKey": null
                                          },
                                          (v30/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "sendAmount",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "receiveAmount",
                                                "storageKey": null
                                              },
                                              (v35/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "senderMobile",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MobileTransferEntry",
                                            "abstractKey": "__isMobileTransferEntry"
                                          }
                                        ],
                                        "type": "TransferSentEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "maybeSenderName",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "maybeSenderMobile",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maybeTerminatedSenderMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "qrText",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantUName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "actionSource",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRefunded",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRemote",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "grossAmount",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v24/*: any*/),
                                              (v23/*: any*/),
                                              (v21/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v36/*: any*/),
                                              (v32/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "MerchantSaleEntry",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "senderOpaqueId",
                                            "storageKey": null
                                          },
                                          (v35/*: any*/),
                                          (v34/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isReversal",
                                            "storageKey": null
                                          },
                                          (v33/*: any*/),
                                          {
                                            "alias": "maybeRecipientName",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "recipientName",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v21/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v36/*: any*/),
                                              (v32/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "PayoutTransferEntry",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "HistoryEntry",
                                    "abstractKey": "__isHistoryEntry"
                                  },
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v22/*: any*/),
                        "filters": [
                          "around",
                          "when"
                        ],
                        "handle": "connection",
                        "key": "MerchantTab_supportHistoryConnection",
                        "kind": "LinkedHandle",
                        "name": "supportHistoryConnection"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Merchant",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac7c271e9dcf54ba2ce4e00401012554",
    "id": null,
    "metadata": {},
    "name": "MerchantTabRefetchQuery",
    "operationKind": "query",
    "text": "query MerchantTabRefetchQuery(\n  $merchantId: ID!\n  $first: Int\n  $after: DateTime\n  $before: DateTime\n  $around: ID\n  $when: DateTime\n  $canReadHistory: Boolean!\n  $canReadBalance: Boolean!\n) {\n  node(id: $merchantId) {\n    __typename\n    ... on Merchant {\n      ...MerchantTab_merchant_2ksLMu\n    }\n    id\n  }\n}\n\nfragment ChangePayoutRecipient_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment HistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment MerchantAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  isDeposit\n  amount\n  cashierName: counterpartyNameOnly\n  cashierMobile: maybeTerminatedCustomerMobile\n  agentId\n  agentUfid\n  agentName\n  subagentId\n  subagentName\n  subagentUfid\n  type\n  isCancelled\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n}\n\nfragment MerchantHistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  __typename\n  ...HistoryEntry_entry\n  ...MerchantSaleEntry_tx\n  ...MerchantTransferSentEntry_tx\n  ...MerchantAtxEntry_tx\n  ...PayoutTransferEntry_tx\n  ...PayoutTransferSentEntry_tx\n}\n\nfragment MerchantSaleEntry_tx on MerchantSaleEntry {\n  maybeTransferId: transferId\n  maybeSenderName: senderName\n  maybeSenderMobile: senderMobile\n  maybeTerminatedSenderMobile\n  qrText\n  merchantUName\n  actionSource\n  isRefunded\n  isRemote\n  ...HistoryEntry_entry\n  ...RefundMerchantSale_transfer\n}\n\nfragment MerchantTab_merchant_2ksLMu on Merchant {\n  id\n  ufid\n  name\n  city\n  region\n  subcity\n  country\n  nearbyLandmark\n  isActive\n  whenDeactivated\n  deactivatedBy\n  deactivatedBecause\n  photos {\n    url\n  }\n  promotedBy {\n    name\n    mobile\n    id\n  }\n  activeKybGracePeriod {\n    kybTierGranted\n  }\n  businessNetwork {\n    name\n    wallets {\n      walletId\n    }\n  }\n  ...MerchantUsersList_merchant\n  wallet {\n    id\n    balance @include(if: $canReadBalance)\n    name\n    mobile\n    kybTier\n    photoEditUrl\n    merchantSupportEscalations {\n      whenOpened\n      status\n      clickupTaskId\n    }\n    supportHistoryConnection(first: $first, after: $after, last: 30, before: $before, around: $around, when: $when) @include(if: $canReadHistory) {\n      edges {\n        node {\n          __typename\n          id\n          ... on MerchantSaleEntry {\n            maybeTransferId: transferId\n          }\n          ... on PayoutTransferEntry {\n            __typename\n            tcid\n            amount\n            whenEntered\n          }\n          ...MerchantHistoryEntry_entry\n          ... on AgentTransactionEntry {\n            agentTransactionId\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        hasPreviousPage\n        hasNextPage\n        startCursor\n        endCursor\n      }\n    }\n  }\n}\n\nfragment MerchantTransferSentEntry_tx on TransferSentEntry {\n  tx_id: transferId\n  sender: senderName\n  mobile: senderMobile\n  recipientName\n  recipientMobile\n  maybeTerminatedRecipientMobile\n  amount\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n  ...RefundP2P_transfer\n}\n\nfragment MerchantUsersList_merchant on Merchant {\n  principal {\n    id\n    name\n    contactMobile\n  }\n  assistants {\n    id\n    name\n    mobile\n  }\n}\n\nfragment PayoutTransferEntry_tx on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  senderName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment PayoutTransferSentEntry_tx on PayoutTransferEntry {\n  tcid\n  senderOpaqueId\n  amount\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment RefundMerchantSale_transfer on MerchantSaleEntry {\n  id\n  maybeTransferId: transferId\n  maybeSenderName: senderName\n  maybeSenderMobile: senderMobile\n  grossAmount\n}\n\nfragment RefundP2P_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  sendAmount\n  receiveAmount\n  senderName\n  senderMobile\n  recipientName\n  maybeTerminatedRecipientMobile\n}\n\nfragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n"
  }
};
})();
(node as any).hash = '41e549a23ab056701e70448c01203f9d';
export default node;
